const DEFAULT_SCALE = 4;
const TABLE_ROW_HEIGHT = 54;
const spacer = {
  spacer1: 4,
  spacer2: 8,
  spacer3: 16,
  spacer4: 24,
  spacer5: 32,
  spacer6: 40,
  spacer7: 80,
};

const sizes = {
  xSmall: 246,
  small: 300,
  xsmedium: 410,
  medium: 640,
  large: 1080,
  extraLarge: 1550,
  borderRadius: '5px',
  drawerWidth: 260,
  appBarHeight: 75,
  footerBarHeight: 48,
  mobileSubHeaderHeight: 50,
};

const borderDefinition = (color = 'rgba(0, 0, 0, 0.12)', borderSize = '1px') => `${borderSize} solid ${color}`;

const boxShadowDefinition = (size = '0px 0px 0px 0px', color = 'rgba(0, 0, 0, 0.2)') => `${size} ${color}`;
const boxShadow = '10px 2px 5px rgba(0, 0, 0, 0.12)';

const dropShadow = '0 2px 3px rgba(0, 0, 0, 0.3)';

const softShadow = '0 5px 10px rgba(0,0,0,.05)';

const boxShadowLight = '0 0 4px 2px rgba(0, 0, 0, 0.03)';

const extraLargeBorderRadius = '50px';

const largeBorderRadius = '25px';

const mediumBorderRadius = '15px';

const smallBorderRadius = '5px';

export {
  borderDefinition,
  boxShadow,
  boxShadowDefinition,
  boxShadowLight,
  DEFAULT_SCALE,
  dropShadow,
  extraLargeBorderRadius,
  largeBorderRadius,
  mediumBorderRadius,
  sizes,
  smallBorderRadius,
  softShadow,
  spacer,
  TABLE_ROW_HEIGHT,
};
